export default "__VITE_ASSET__CpNpzbh5__"